export default __webpack_public_path__ + "static/media/42.c5f53d30.jpeg";